module.exports = __webpack_public_path__ + "static/offices-content-image-square-two@2x-8b41f53548140ebde62bc6ee39bb86d4.jpg";